import util from 'preact-util';

/**
 * Race lookup shared by the help center and the quick-search overlay.
 *
 * Only race domains (the same gate that shows the Race menu entry) search races. The
 * backend route matches any query word against race titles and returns at most five
 * summary rows, so «Villroa race påmelding 2026» lands on the race page instead of a
 * zero-hit gap.
 */

export const RACE_SEARCH_URL = '/api/races/public/search';
export const RACE_SEARCH_MIN_CHARS = 3;

export function isRaceDomain(currentCustomer) {
    return !!currentCustomer?.menuItems?.liverace;
}

export function raceRoute(race) {
    return `/race/${race.id}`;
}

/**
 * Resolves to the race hits for `search`, or [] when the domain has no races, the query
 * is too short, or the request fails. Never throws. `fetchApi` is injectable for tests.
 */
export async function searchRaces({ search, currentCustomer, fetchApi = util.fetchApi }) {
    const query = String(search || '').trim();
    if (!isRaceDomain(currentCustomer) || query.length < RACE_SEARCH_MIN_CHARS) {
        return [];
    }
    try {
        const response = await fetchApi(RACE_SEARCH_URL, { method: 'GET' }, { q: query });
        return response?.status === 200 && Array.isArray(response.data) ? response.data : [];
    } catch (err) {
        return [];
    }
}
